import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import {
  NativeStackNavigationProp,
  createNativeStackNavigator,
} from "@react-navigation/native-stack";
import { UserLoggedInNavigatorNavigationProp } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { TeamIcon } from "./__generated__/RoutineDetailScreenTopTaskIssueCreator_Routine.graphql";

type RoutineDetailStackParamList = {
  RoutineDetailMain: {
    routineTitle: string;
    routineId: string;
    teamId?: string;
  };
  TaskAllIssues: {
    taskId: string;
    taskTitle: string;
    section: {
      id: string;
      title: string;
      icon: TeamIcon | null;
    } | null;
  };
  RoutinesOcassionsFollowup: {
    routineTitle: string;
    routineId: string;
    teamId?: string;
  };
};

export const RoutineDetailStack =
  createNativeStackNavigator<RoutineDetailStackParamList>();

export type RoutineDetailNavigatorNavigationProp<
  T extends keyof RoutineDetailStackParamList,
> = CompositeNavigationProp<
  UserLoggedInNavigatorNavigationProp<"RoutineDetail">,
  NativeStackNavigationProp<RoutineDetailStackParamList, T>
>;

type RoutineDetailNavigatorRouteProp<
  T extends keyof RoutineDetailStackParamList,
> = RouteProp<RoutineDetailStackParamList, T>;

export type RoutineDetailNavigatorScreenProps<
  T extends keyof RoutineDetailStackParamList,
> = {
  navigation: RoutineDetailNavigatorNavigationProp<T>;
  route: RoutineDetailNavigatorRouteProp<T>;
};
